import { enqueueSnackbar, UploadFile } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	RemoveEBandIpsRequest
} from '../requests/RemoveEBandIpsRequests.js';

export const REMOVE_E_BAND_IPS = 'REMOVE_E_BAND_IPS';

export const GetRemoveEBandIps = (filePath, userName, userId) => async (dispatch) => {
	await RemoveEBandIpsRequest(filePath, userName, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RunRemoveEBandIps = (file, userName, userId) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(GetRemoveEBandIps(response.data, userName, userId));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
